var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53498_12861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6C3.1582 6 0.0703125 12.4336 0.0703125 12.4336L-0.0820312 12.75L0.0703125 13.0664C0.0703125 13.0664 3.1582 19.5 11.25 19.5C19.3418 19.5 22.4297 13.0664 22.4297 13.0664L22.5762 12.75L22.4297 12.4336C22.4297 12.4336 19.3418 6 11.25 6ZM11.25 7.5C14.1562 7.5 16.5 9.84375 16.5 12.75C16.5 15.6562 14.1562 18 11.25 18C8.34375 18 6 15.6562 6 12.75C6 9.84375 8.34375 7.5 11.25 7.5ZM5.91211 8.66602C5.03906 9.80273 4.5 11.209 4.5 12.75C4.5 14.291 5.03906 15.6973 5.91211 16.834C3.03516 15.4043 1.86328 13.1309 1.67578 12.75C1.86328 12.3691 3.03516 10.0957 5.91211 8.66602ZM16.5879 8.66602C19.4648 10.0957 20.6367 12.3691 20.8242 12.75C20.6367 13.1309 19.4648 15.4043 16.5879 16.834C17.4609 15.6973 18 14.291 18 12.75C18 11.209 17.4609 9.80273 16.5879 8.66602ZM11.25 10.5C10.0078 10.5 9 11.5078 9 12.75C9 13.9922 10.0078 15 11.25 15C12.4922 15 13.5 13.9922 13.5 12.75C13.5 11.5078 12.4922 10.5 11.25 10.5Z",
    fill: "#454A54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53498_12861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeVisible);
export default __webpack_public_path__ + "static/media/eye-visible.ff9d2891c531af4a5b68772eb94bde21.svg";
export { ForwardRef as ReactComponent };